import React from 'react'
import { Drawer } from 'components/ui'
import withHeaderItem from 'utils/hoc/withHeaderItem'
import { setAuthPanelResetPasswordExpand } from 'store/theme/themeSlice'
import { useSelector, useDispatch } from 'react-redux'
import { IconText } from 'components/shared'

import useResponsive from 'utils/hooks/useResponsive'
import Logo from '../Logo'

import ForgotPassword from 'views/auth/ForgotPassword'

export const AuthSidePanelReset = () => {
    const dispatch = useDispatch()

    const authPanelResetPasswordExpand = useSelector(
        (state) => state.theme.authPanelResetPasswordExpand
    )

    const direction = useSelector((state) => state.theme.direction)
    const { windowWidth } = useResponsive()

    const closePanel = () => {
        dispatch(setAuthPanelResetPasswordExpand(false))
        const bodyClassList = document.body.classList
        if (bodyClassList.contains('drawer-lock-scroll')) {
            bodyClassList.remove('drawer-lock-scroll', 'drawer-open')
        }
    }
    const getDrawerWidth = () => {
        if (windowWidth < 640) return windowWidth
        if (windowWidth < 1024) return windowWidth * 0.8
        return windowWidth / 2
    }

    return (
        <>
            <Drawer
                headerClass={'hidden'}
                isOpen={authPanelResetPasswordExpand}
                onClose={closePanel}
                onRequestClose={closePanel}
                placement={direction === 'rtl' ? 'left' : 'right'}
                width={getDrawerWidth()}
                className="bg-red-400 overflow-hidden"
                bodyClass={'p-0 bg-gray-200 overflow-hidden'}
                overlayClassName="z-40"
            >
                <div className="flex items-end mx-6 my-3 justify-end">
                    <span
                        className="cursor-pointer font-normal"
                        onClick={closePanel}
                    >
                        <IconText className="text-blue-500">Close</IconText>
                    </span>
                </div>
                <div className="m-4 p-10 md:p-24 mb-0 pb-0 border border-b-0 bg-white h-full  flex flex-col">
                    <div className="w-full mx-auto pt-20">
                        <div className="mb-1">
                            <Logo
                                type="full"
                                className="!mx-0"
                                imgClass="!px-0"
                            />
                        </div>
                        <ForgotPassword />
                    </div>
                </div>
            </Drawer>
        </>
    )
}

export default withHeaderItem(AuthSidePanelReset)
